module.exports = __webpack_public_path__ + "img/hospital_bed.985048c1.svg";